import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import { predictPageToRequestAfterItemDeletion } from '@atlassian/jira-common-pagination/src/index.tsx';
import { FETCH_COMPONENTS_REASON } from '../common/constants/fetch-components-reason.tsx';
import {
	DELETE_COMPONENT_SUCCESS,
	getComponentsPageRequest,
	type Action,
} from '../state/actions.tsx';
import { getTotalItems } from '../state/components/selectors.tsx';
import { getCurrentPage } from '../state/query/selectors.tsx';
import type { State } from '../state/reducer.tsx';
import { getItemsOnPage as getComponentsPerPage } from '../state/ui/page/selectors.tsx';

export const successfulDelete = (action$: ActionsObservable<Action>, store: MiddlewareAPI<State>) =>
	action$.ofType(DELETE_COMPONENT_SUCCESS).mergeMap(() => {
		const state = store.getState();
		const componentsPerPage = getComponentsPerPage(state);
		const totalComponents = getTotalItems(state);
		const currentPage = getCurrentPage(state);

		const predictedPage = predictPageToRequestAfterItemDeletion(
			componentsPerPage,
			totalComponents,
			currentPage,
		);

		return Observable.of(
			getComponentsPageRequest({
				page: predictedPage,
				initiatedBy: FETCH_COMPONENTS_REASON.COMPONENT_DELETED,
			}),
		);
	});
